// Copyright (C) 2020 TANNER AG

import React from "react";
import { compose } from "recompose";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import VideocamIcon from '@material-ui/icons/Videocam';
import ButtonBase from '@material-ui/core/ButtonBase'

const styles = theme => ({
    containerStyle: {
        flex: '1 0 auto',
        padding: '0 36px 100px 36px',
        background: '#fafafa'
    },
    gridStyle: {
        maxWidth: 1200,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    contentContainerStyle: {
        marginTop: 70,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    headingStyle: {
        marginBottom: 20
    },
    paginationContainerStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    paginationBaseLinkStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        backgroundColor: '#fff',
        color: '#303a44',
        border: '1px solid #d6d8db',
        minWidth: 40,
        width: 40,
        height: 40,
        padding: 10,
        marginLeft: -1,
        '&:hover, &:focus': {
            zIndex: 2,
            backgroundColor: '#e2e3e4'
        }
    },
    paginationActiveLinkStyle: {
        backgroundColor: '#303c49',
        borderColor: '#303c49',
        zIndex: 3,
        color: '#d6d8db',
        '&:hover, &:focus, &:active': {
            backgroundColor: '#303c49',
            borderColor: '#303c49',
            zIndex: 3,
            color: '#d6d8db',
        }
    },
    paginationLeftLinkStyle: {
        marginLeft: 0,
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
    },
    paginationRightLinkStyle: {
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
    },
    labelColorStyle: {
        color: 'currentColor'
    }
})

const PodcastsTypeFilter = ({ classes: {
    paginationContainerStyle,
    paginationBaseLinkStyle,
    paginationLeftLinkStyle,
    paginationRightLinkStyle,
    paginationActiveLinkStyle
}, selected, onClick }) => {
    return (
        <div className={paginationContainerStyle}>
            <ButtonBase
                className={classNames(
                    paginationBaseLinkStyle,
                    paginationLeftLinkStyle,
                    {
                        [paginationActiveLinkStyle]: selected.includes("audio")
                    }
                )}
                title="Audio"
                onClick={() => onClick("audio")}
            >
                <AudiotrackIcon size={12} />
            </ButtonBase>
            <ButtonBase
                className={classNames(
                    paginationBaseLinkStyle,
                    paginationRightLinkStyle,
                    {
                        [paginationActiveLinkStyle]: selected.includes("video")
                    }
                )}
                title="Video"
                onClick={() => onClick("video")}
            >
                <VideocamIcon size={12} />
            </ButtonBase>
        </div>
    );
};

PodcastsTypeFilter.propTypes = {
    selected: PropTypes.array,
    onClick: PropTypes.func
};

export default compose(
    withStyles(styles)
)(PodcastsTypeFilter);



// WEBPACK FOOTER //
// ./src/components/PodcastsTypeFilter.js